import React, { useCallback, useEffect, useState } from 'react';
import { IsWeb } from './Platform';
const LogoComponent = () => {
  let isWebView = IsWeb();
  return isWebView ? (
    <img
      src={require('../../images/logo.png')}
      style={{ width: '150px' }}
      alt="Woosla"
      className="logo"
    />
  ) : (
    <>
      <img
        src={require('../../images/mini-logo.png')}
        style={{ height: '50px', aspectRatio: 1 }}
        alt="Woosla"
        className="logo"
      />
      <span className="logoTxt">Woosla</span>
    </>
  );
};

export default LogoComponent;
